(function() {
'use strict';

angular
    .module('TR')
    .controller('SelectedHotel', SelectedHotel);

function SelectedHotel(hotelFromSession, arrayUtil, imageService, $q, tripService, $routeParams, basketStore, $route, basketService, taxationService, mandatoryTransferService) {
    const sh = this;
    const w = TRPCONFIG.DeviceSettings.HotelImageMaxWidth;
    const h = TRPCONFIG.DeviceSettings.HotelImageMaxHeight;

    sh.changeWorkflowState = changeWorkflowState;
    sh.openImageGallery = openImageGallery;
    sh.hotelImageIndex = 0;
    sh.showHotelImages = false;
    sh.isPackagePrice = TRPCONFIG.Domain.PackagePrice && $route.current && $route.current.area === 'holidays';
    sh.priceExcludesTax = TRPCONFIG.Domain.PriceExcludesTax || false;
    tripService.usePackageRates().then(packagePrice => sh.isPackagePrice = packagePrice);

    function changeWorkflowState(breadcrumb) {
        basketService.changeJourneyUrl(breadcrumb);
    }

    function openImageGallery() {
        sh.showHotelImages = true;
    }

    tripService.getTrip($routeParams.tripId).then(function(trip) {
        if (trip && trip.BasketId) {
            taxationService.getCityTax(trip.TripId, trip.BasketId).then(tax => {
                sh.tax = tax;
            });
            $q.all([basketStore.hotel(trip.BasketId),
                    basketStore.hotelCost(trip.BasketId),
                    basketStore.hotelDeposit(trip.BasketId, $routeParams.productId)]).then(function(results) {
                const hotelFromBasket = results[0];
                if (hotelFromBasket) {
                    sh.hotelCost = results[1];
                    sh.hotelDeposit = results[2];
                    sh.hotelImages = arrayUtil.map(arrayUtil.numberArray(0, hotelFromBasket.Details.NumberOfPhotos - 1), function(i) {
                        return {
                            src: imageService.getImageUrl(hotelFromBasket.Details.Id, w, h, i, false)
                        };
                    });
                    sh.mandatoryTransfersCost = mandatoryTransferService.getBookedTransfersPrice(hotelFromBasket.CostBreakdown);
                    hotelFromSession.getHotel(trip.HotelsRequest.AvailabilitySearchId, hotelFromBasket.Details.Id, $routeParams.tripId).then(function(hotel) {
                        sh.hotel = angular.extend(hotel, hotelFromBasket);
                    });
                }
            });
        }
    });
}
})();
